import { render, staticRenderFns } from "./QuestionInfoChannel.vue?vue&type=template&id=72af3f7c&"
import script from "./QuestionInfoChannel.vue?vue&type=script&lang=ts&"
export * from "./QuestionInfoChannel.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionInfoChannel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports